import styled from "styled-components"
import { Button, Input, Typography, message, Row, Col, Modal, ImageFileId, LucideIcon } from "../../../ui/ot"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../ui/tooltip"

import { useTranslation } from "react-i18next";
import { useMARCFile2Json } from './../../controllers/MARCFile2JsonController'
import React, { useEffect, useState, useRef } from "react";
import dayjs from 'dayjs';
import { useBib } from "../../controllers/BibController";
import { FaCopy, FaPlus } from 'react-icons/fa';
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "../../../ui/table"
import { Tabs } from "../../../ui/ot";
import { Radio } from "../../../ui/ot";
const StageMARCRecord = ({
    permission_level = null, 
}) => {
    const fileInputRef = useRef(null);
    const currentImportKey = useRef(0)
    const [selectedTab, setSelectedTab] = useState('全部');

    const { t } = useTranslation('translation', { keyPrefix: 'library.stage_marc_record' });
    const [lastUploadTime, setLastUploadTime] = useState(undefined)
    const [importFailed, setImportFailed] = useState([])
    const [importDuplicate, setImportDuplicate] = useState([])
    const [loading, setLoading] = useState(false)
    const [tempBibData, setTempBibData] = useState([])
    const [selectedFile, setSelectedFile] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const duplicateOptions = [
        {
            id: 1,
            name: "覆蓋書目並新增館藏",
        },
        {
            id: 2,
            name: "另外新增書目以及館藏",
        },
        {
            id: 3,
            name: "僅新增館藏",
        },
    ];
    // const onUpload = (e) => {
    //     setSelectedTab("全部");
    //     let file = null
    //     for (let index = 0; index < e.target.files.length; index++) {
    //         file = e.target.files[index];
    //     }
    //     let form_data = new FormData();
    //     form_data.append('file', file);
    //     // console.log(thisJS, "onUpload", form_data)
    //     postMARCFile2JsonData(form_data)
    //     setImportFailed([]);
    //     setImportDuplicate([]);
    // }
    const onUpload = (e) => {
        setSelectedTab("全部");
        setSelectedFile(e.target.files[0] ?? null);
        setTempBibData([]);
        setLastUploadTime(undefined);
        setImportFailed([]);
        setImportDuplicate([]);
    }
    // const onFormFinish = () => {
    //     if (tempBibData.length > 0) {
    //         let bib_duplicate_data = tempBibData.filter((item, inx) => item?.duplicate_mode !== undefined);
    //         let bib_new_data = tempBibData.filter((item, inx) => item?.duplicate_mode === undefined);
    //         let patch_duplicate_final = []
    //         let post_final = []
    //         let post_after_post_final = []
    //         if (bib_duplicate_data.length > 0) {
    //             let bib_duplicate_replace_data = bib_duplicate_data.filter((item, inx) => item?.duplicate_mode === 1);
    //             let bib_duplicate_create_data = bib_duplicate_data.filter((item, inx) => item?.duplicate_mode === 2);
    //             let bib_duplicate_create_item_data = bib_duplicate_data.filter((item, inx) => item?.duplicate_mode === 3);
    //             if (bib_duplicate_replace_data.length > 0) {
    //                 let set_biblionumber = bib_duplicate_replace_data.map(bib_data => {
    //                     return {
    //                         ...bib_data,
    //                         biblionumber: bib_data?.bib_biblionumber
    //                     }
    //                 })
    //                 patch_duplicate_final.push(...set_biblionumber)
    //                 post_final.push(...set_biblionumber)
    //                 // console.log({set_biblionumber})
    //                 // patchBibData(set_biblionumber).then(() => postBibData(set_biblionumber));
    //             }
    //             if (bib_duplicate_create_data.length > 0) {
    //                 let change_biblionumber = bib_duplicate_create_data.map(bib_data => {
    //                     let newData = {
    //                         ...bib_data,
    //                         bib_biblionumber: -1
    //                     }
    //                     // delete newData.bib_biblionumber;
    //                     return newData
    //                 })
    //                 let change_duplicate_mode = bib_duplicate_create_data.map(bib_data => {
    //                     let newData = {
    //                         ...bib_data,
    //                         duplicate_mode: 3
    //                     }
    //                     return newData
    //                 })
    //                 post_final.push(...change_biblionumber)
    //                 post_after_post_final.push(...change_duplicate_mode)
    //                 // console.log({change_biblionumber})
    //                 // console.log({change_duplicate_mode})
    //                 // postBibData(change_biblionumber).then(() => postBibData(change_duplicate_mode));
    //             }
    //             if (bib_duplicate_create_item_data.length > 0) {
    //                 post_final.push(...bib_duplicate_create_item_data)
    //                 // console.log({bib_duplicate_create_item_data})
    //                 // postBibData(bib_duplicate_create_item_data)
    //             }
    //         }
    //         if (bib_new_data.length > 0) {
    //             post_final.push(...bib_new_data)
    //         }
    //         patchBibData(patch_duplicate_final).then(() => {
    //             postBibData(post_final)
    //             setLoading(true)
    //         });
    //         setLoading(true)

    //     }
    //     else {
    //         message.info("請上傳檔案")
    //     }
    // }
    // const onFormFinish = async () => {
    //     if (tempBibData.length > 0) {
    //         setLoading(true);
    //         let invalidDuplicateModeList = []; // 記錄未處理的資料
    //         let failedList = []; // 記錄匯入失敗的資料

    //         for (let i = 0; i < tempBibData.length; i++) {
    //             const item = tempBibData[i];

    //             // 檢查重複書目但未選擇處理方式
    //             if (
    //                 item?.bib_is_exist === true &&
    //                 ![1, 2, 3].includes(item?.duplicate_mode)
    //             ) {
    //                 invalidDuplicateModeList.push(item);
    //                 continue; // 跳過這筆
    //             }

    //             let response;
    //             try {
    //                 if (item?.duplicate_mode === 1) {
    //                     // 覆蓋書目
    //                     response = await patchBibData([{ ...item, biblionumber: item?.bib_biblionumber }]);
    //                 } else if (item?.duplicate_mode === 2) {
    //                     // 另外新增書目以及館藏
    //                     response = await postBibData([{ ...item, bib_biblionumber: -1 }]);
    //                     if (response?.status === "success") {
    //                         response = await postBibData([{ ...item, duplicate_mode: 3 }]);
    //                     }
    //                 } else {
    //                     // 新書目或僅新增館藏
    //                     response = await postBibData([item]);
    //                 }

    //                 // 判斷 response 狀態
    //                 if (response?.status !== "success") {
    //                     failedList.push({ ...item, error: response?.message || "匯入失敗" });
    //                     message.error(`第${i + 1}筆：${response?.message || "匯入失敗"}`);
    //                     continue; // 不中斷，繼續下一筆
    //                 }
    //             } catch (err) {
    //                 console.log(err)
    //                 failedList.push({ ...item, error: err?.message || "匯入發生例外錯誤" });
    //                 message.error(`第${i + 1}筆：${err?.message || "匯入發生例外錯誤"}`);
    //                 continue; // 不中斷，繼續下一筆
    //             }
    //             console.log({
    //                 response
    //             })
    //         }
    //         setLoading(false);

    //         if (invalidDuplicateModeList.length > 0) {
    //             message.warning(`有 ${invalidDuplicateModeList.length} 筆重複書目未選擇處理方式，未執行匯入。`);
    //         }
    //         if (failedList.length > 0) {
    //             message.error(`有 ${failedList.length} 筆匯入失敗，請檢查錯誤訊息。`);
    //         }
    //         if (invalidDuplicateModeList.length === 0 && failedList.length === 0) {
    //             message.success("全部匯入成功！");
    //         }
    //     } else {
    //         message.info("請上傳檔案");
    //     }
    // }
    const onFormFinish = async () => {
        if (tempBibData.length === 0) {
            if (!selectedFile) {
                message.info("請先選擇檔案");
                return;
            }
            const form_data = new FormData();
            form_data.append('file', selectedFile);
            postMARCFile2JsonData(form_data);
            return;
        }
        if (tempBibData.length > 0) {
            setLoading(true);

            // 1. 先過濾掉重複書目但未選擇模式的資料
            let invalidDuplicateModeList = tempBibData.filter(
                item => item?.bib_is_exist === true && ![1, 2, 3].includes(item?.duplicate_mode)
            );
            // 只留下合法可匯入的資料
            let validData = tempBibData.filter(
                item => !(item?.bib_is_exist === true && ![1, 2, 3].includes(item?.duplicate_mode))
            );

            // 2. 分類
            let bib_duplicate_data = validData.filter(item => item?.duplicate_mode !== undefined);
            let bib_new_data = validData.filter(item => item?.duplicate_mode === undefined);

            let patch_duplicate_final = [];
            let post_final = [];
            let post_after_post_final = [];

            // 3. 處理重複書目
            if (bib_duplicate_data.length > 0) {
                let bib_duplicate_replace_data = bib_duplicate_data.filter(item => item?.duplicate_mode === 1);
                let bib_duplicate_create_data = bib_duplicate_data.filter(item => item?.duplicate_mode === 2);
                let bib_duplicate_create_item_data = bib_duplicate_data.filter(item => item?.duplicate_mode === 3);

                // 覆蓋書目
                if (bib_duplicate_replace_data.length > 0) {
                    let set_biblionumber = bib_duplicate_replace_data.map(bib_data => ({
                        ...bib_data,
                        biblionumber: bib_data?.bib_biblionumber
                    }));
                    patch_duplicate_final.push(...set_biblionumber);
                    post_final.push(...set_biblionumber);
                }
                // 另外新增書目
                if (bib_duplicate_create_data.length > 0) {
                    let change_biblionumber = bib_duplicate_create_data.map(bib_data => ({
                        ...bib_data,
                        bib_biblionumber: -1
                    }));
                    let change_duplicate_mode = bib_duplicate_create_data.map(bib_data => ({
                        ...bib_data,
                        duplicate_mode: 3
                    }));
                    post_final.push(...change_biblionumber);
                    post_after_post_final.push(...change_duplicate_mode);
                }
                // 僅新增館藏
                if (bib_duplicate_create_item_data.length > 0) {
                    post_final.push(...bib_duplicate_create_item_data);
                }
            }
            // 4. 處理新書目
            if (bib_new_data.length > 0) {
                post_final.push(...bib_new_data);
            }

            // 5. 執行批次 API
            let patchResult, postResult, postAfterResult;
            try {
                if (patch_duplicate_final.length > 0) {
                    patchResult = await patchBibData(patch_duplicate_final);
                    // if (patchResult?.status !== "success") {
                    //     message.error(patchResult?.message || "patch 匯入失敗");
                    // }
                }
                if (post_final.length > 0) {
                    // postResult = await postBibData(post_final);
                    // if (postResult?.status !== "success") {
                    //     message.error(postResult?.message || "post 匯入失敗");
                    // }
                }
                if (post_after_post_final.length > 0) {
                    // postAfterResult = await postBibData(post_after_post_final);
                    post_final = [...post_final, ...post_after_post_final]
                    // if (postAfterResult?.status !== "success") {
                    //     message.error(postAfterResult?.message || "post(館藏) 匯入失敗");
                    // }
                }
                if (post_final.length > 0) {
                    postResult = await handlePost(post_final);
                    postAfterResult = postResult
                }
            } catch (err) {
                message.error(err?.message || "批次匯入發生例外錯誤");
            }

            setLoading(false);

            if (invalidDuplicateModeList.length > 0) {
                message.warning(`有 ${invalidDuplicateModeList.length} 筆重複書目未選擇處理方式，未執行匯入。`);
            }
            if (
                (!patchResult || patchResult?.status === "success") &&
                (!postResult || postResult?.status === "success") &&
                (!postAfterResult || postAfterResult?.status === "success") &&
                invalidDuplicateModeList.length === 0
            ) {
                message.success("全部匯入成功！");
            }
        } 
        // else {
        //     message.info("請上傳檔案");
        // }
    }
    function removeDuplicateEntries(bookArray, duplicateMessage) {
        // 從 "重複的書目：" 之後提取真正的書名
        const duplicateTitle = duplicateMessage.replace("重複的書目：", "").trim();

        // 找到該書目的索引
        const duplicateIndex = bookArray.findIndex(book => book.bib_title === duplicateTitle);

        // 如果找到，回傳從該索引開始的陣列
        return duplicateIndex !== -1 ? bookArray.slice(duplicateIndex) : bookArray;
    }
    const showImportStatus = ({ status_name, message }) => {
        let color = "#333";
        let icon = "Upload"
        let text = status_name || "尚未匯入";
        let showTooltip = false;

        if (status_name === "匯入成功") {
            color = "#28a745"; // 綠色
            icon = "CircleCheckBig"

        } else if (status_name === "匯入失敗") {
            color = "#dc3545"; // 紅色
            icon = "CircleX"
            showTooltip = true;
        } else if (status_name === "尚未匯入" || !status_name) {
            color = "#ffc107"; // 黃色
            icon = "Upload"
            showTooltip = true;
        }

        const content = (
            <span style={{ color, cursor: showTooltip ? "pointer" : "default", whiteSpace: "nowrap", }}>
                {text}
            </span>
        );

        return showTooltip && message ? (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        {content}
                    </TooltipTrigger>
                    <TooltipContent>
                        {message}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        ) : content;
    };
    const {
        MARCFile2JsonData,
        postMARCFile2JsonData
    } = useMARCFile2Json({
        onBefore: ({ axiosMode, values }) => {
            // console.log(thisJS, "postMARCFile2JsonData OnBefore", values)
            if (axiosMode === "post") {
                setLoading(true)
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "postMARCFile2JsonData onFinish", status, values)
            if (axiosMode === "post") {
                if (status === "success") {
                    setLastUploadTime(dayjs().format('YYYY-MM-DD HH:mm'))
                    setLoading(false)
                }
                else {
                    message.error(values?.message || "檔案轉換失敗")
                    setLoading(false)
                    return;
                }
            }
        }
    })
    const {
        postBibData,
        patchBibData
    } = useBib({
        onBefore: ({ axiosMode, values }) => {
            // console.log(thisJS, "postBibData onBefore", values)
            let data = values
            data?.forEach(element => {
                if (!!element?.bib_is_exist && !element?.duplicate_mode) {
                    setTempBibData((pre) => {
                        let newTemp = pre.map((val, index) => {
                            if (element?.key === val?.key) {
                                return {
                                    ...val,
                                    import_status: "尚未新增",
                                    import_message: "未選擇匯入模式，請選擇"
                                }
                            }
                            else {
                                return {
                                    ...val,
                                    import_status: "尚未新增",
                                }
                            }

                        })
                        return newTemp
                    })
                }

            });

        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log({ axiosMode, status, values })
            let data = values?.data || []
            if (axiosMode === "post") {
                if (status === "success") {
                    data.forEach((element) => {
                        let result = element?.result
                        let resultStatus = result?.status
                        let resultMessage = result?.message || "匯入成功"
                        setTempBibData((pre) => {
                            let newTemp = pre.map((val, index) => {
                                if (val?.key === element?.key) {
                                    if (resultStatus === "success") {
                                        return {
                                            ...val,
                                            import_status: "匯入成功",
                                            import_message: resultMessage
                                        }
                                    }
                                    else {
                                        return {
                                            ...val,
                                            import_status: "匯入失敗",
                                            import_message: resultMessage
                                        }
                                    }

                                }
                                else {
                                    return {
                                        ...val
                                    }
                                }

                            })
                            return newTemp
                        })
                    })

                }
                else {
                    data.forEach((element) => {
                        let result = element?.result
                        let resultStatus = result?.status
                        let resultMessage = result?.message || "匯入成功"
                        setTempBibData((pre) => {
                            let newTemp = pre.map((val, index) => {
                                if (val?.key === element?.key) {
                                    if (resultStatus === "success") {
                                        return {
                                            ...val,
                                            import_status: "匯入成功",
                                            import_message: resultMessage
                                        }
                                    }
                                    else {
                                        return {
                                            ...val,
                                            import_status: "匯入失敗",
                                            import_message: resultMessage
                                        }
                                    }

                                }
                                else {
                                    return {
                                        ...val
                                    }
                                }

                            })
                            return newTemp
                        })
                    })
                }
            }
            else if (axiosMode === "patch") {
                if (status === "success") {
                    data.forEach((element) => {
                        let result = element?.result
                        let resultStatus = result?.status
                        let resultMessage = result?.message || "匯入成功"
                        setTempBibData((pre) => {
                            let newTemp = pre.map((val, index) => {
                                if (val?.key === element?.key) {
                                    if (resultStatus === "success") {
                                        return {
                                            ...val,
                                            import_status: "匯入成功",
                                            import_message: resultMessage
                                        }
                                    }
                                    else {
                                        return {
                                            ...val,
                                            import_status: "匯入失敗",
                                            import_message: resultMessage
                                        }
                                    }

                                }
                                else {
                                    return {
                                        ...val
                                    }
                                }

                            })
                            return newTemp
                        })
                    })

                }
                else {
                    data.forEach((element) => {
                        let result = element?.result
                        let resultStatus = result?.status
                        let resultMessage = result?.message || "匯入成功"
                        setTempBibData((pre) => {
                            let newTemp = pre.map((val, index) => {
                                if (val?.key === element?.key) {
                                    if (resultStatus === "success") {
                                        return {
                                            ...val,
                                            import_status: "匯入成功",
                                            import_message: resultMessage
                                        }
                                    }
                                    else {
                                        return {
                                            ...val,
                                            import_status: "匯入失敗",
                                            import_message: resultMessage
                                        }
                                    }

                                }
                                else {
                                    return {
                                        ...val
                                    }
                                }

                            })
                            return newTemp
                        })
                    })
                }
            }
        },
    })
    function chunkArray(array, size) {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    }

    async function handlePost(post_final) {
        const chunked = chunkArray(post_final, 50);

        for (let i = 0; i < chunked.length; i++) {
            const batch = chunked[i];
            try {
                console.log(`正在送出第 ${i + 1} 批，共 ${chunked.length} 批`);
                await postBibData(batch);   // 逐批等待
                console.log(`第 ${i + 1} 批完成`);
            } catch (err) {
                console.error(`第 ${i + 1} 批失敗:`, err);
                // 這裡可視需求決定要不要中斷 or 繼續
            }
        }

        console.log("全部批次完成 ✅");
    }

    useEffect(() => {
        document.title = t('Stage_MARC_records_for_import')
    }, []);
    useEffect(() => {
        setTempBibData(MARCFile2JsonData.map((value)=>{
            return {
                ...value,
                import_status:"尚未新增"
            }
        }));
        if (MARCFile2JsonData?.length > 0) {
            setSelectedTab("全部");
        }
    }, [MARCFile2JsonData]);
    useEffect(() => {
        // console.log({selectedTab})
    }, [selectedTab])
    useEffect(() => {
        setFilteredData(tempBibData.filter(item => {
            if (selectedTab === '全部') return true;
            if (selectedTab === '重複書目') return item?.bib_is_exist;
            if (selectedTab === '無重複書目') return !item?.bib_is_exist;
            return true;
        }))
    }, [tempBibData, selectedTab])
    return (<>
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row justify="center" gutter={[8, 8]}>
                    <Col xxl={7} xl={7} lg={12} sm={24} md={24} xs={24} >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Title>{t('Stage_MARC_records_for_import')}</Title>

                            </Col>
                            <Col span={24}>
                                <PScontext>
                                    • {t('Select_a_MARC_file_to_stage_in_the_import_reservoir_It_will_be_parsed_and_each_valid_record_staged_for_later_import_into_the_catalog')}
                                </PScontext>
                            </Col>
                            {/* <Col span={24}>
                                <PScontext>
                                    • {t('You_can_enter_a_name_for_this_import_It_may_be_useful_when_creating_a_record_to_remember_where_the_suggested_MARC_data_comes_from')}
                                </PScontext>
                            </Col> */}
                            {(permission_level?.permission_level === 1 || permission_level === 1) ? 
                            <Col span={24}>
                                <Input ref={fileInputRef} type="file" accept=".mrc,.marc,.mrk,.iso,.out" onChange={onUpload} />
                            </Col>
                            : <></>}

                            {lastUploadTime && <Col span={24}> <Typography.P>{t("最後暫存時間")}：{lastUploadTime}</Typography.P>  </Col>}
                            {lastUploadTime && <Col span={24}> <Typography.P style={{ color: "#007BFF" }}>{t("最後暫存筆數")}：{tempBibData?.length ?? 0}</Typography.P> </Col>}
                            {lastUploadTime && <Col span={24}> <Typography.P style={{ color: "#721C24" }}>{t("內含重複筆數")}：{
                                (tempBibData || []).reduce(
                                    (sum, { bib_is_exist }) => sum + (bib_is_exist ? 1 : 0), 0
                                )
                            }</Typography.P> </Col>}
                            {lastUploadTime && <Col span={24}>
                                <Typography.P>{t("重複書目清單")}：</Typography.P>
                                <ul> {
                                    (tempBibData || []).map((marcData) => {
                                        if (marcData?.bib_is_exist) {
                                            return (
                                                <li key={marcData.key}>{marcData.bib_title}</li>
                                            )
                                        } else {
                                            return (<React.Fragment key={marcData.key}></React.Fragment>)
                                        }
                                    })
                                }</ul>
                            </Col>}
                            {(permission_level?.permission_level === 1 || permission_level === 1) ? 
                            <Col span={24}>
                                <Button
                                    style={{ width: '100%' }}
                                    loading={loading}
                                    onClick={onFormFinish}>
                                    {t('upload_file')}
                                </Button>
                            </Col>
                            : <></>}
                            <Col span={24}>
                                {importDuplicate.length > 0 && <>
                                    <Typography.P>{t("重複書目清單")}：</Typography.P>
                                    <ul> {
                                        importDuplicate.map((marcData) => {
                                            return (
                                                <li key={marcData.key}>{marcData.bib_title}</li>
                                            )
                                        })
                                    }</ul>
                                </>}
                            </Col>
                        </Row>
                    </Col>
                    {tempBibData.length > 0 && (
                        <Col xxl={17} xl={17} lg={12} sm={24} md={24} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Table style={{ width: '100%', height: '90vh' }}>
                                        <TableHeader
                                            style={{ position: 'sticky' }}
                                        >
                                            <TableRow>
                                                <TableCell colSpan={2}>總筆數:{tempBibData.length}</TableCell>
                                                <TableCell colSpan={5} className="text-right ">
                                                    <Row gutter={[4, 4]} justify="end">
                                                        <Col>
                                                            <Button
                                                                onClick={() => {
                                                                    fileInputRef.current.value = ''
                                                                    setTempBibData([])
                                                                }}>
                                                                清空所有，上傳新一筆
                                                            </Button>
                                                        </Col>
                                                        <Col>
                                                            <Button
                                                                onClick={() => {
                                                                    setTempBibData((pre => {
                                                                        console.log({pre})
                                                                        
                                                                        let newArr = pre.filter((ele) => !(ele?.import_status === "匯入成功"));
                                                                        return newArr
                                                                    }))
                                                                }}>
                                                                一鍵清除匯入成功書目
                                                            </Button>
                                                        </Col>
                                                        <Col>
                                                            <Button
                                                                onClick={() => {
                                                                    setTempBibData((pre => {
                                                                        let newArr = pre.filter((ele) => !ele?.bib_is_exist);
                                                                        return newArr
                                                                    }))
                                                                }}>
                                                                一鍵刪除重複書目
                                                            </Button>
                                                        </Col>
                                                        {duplicateOptions.map((opt) => (
                                                            <Col key={opt?.id}>
                                                                <Button
                                                                    onClick={() => {
                                                                        setTempBibData((pre) =>
                                                                            pre.map((item) =>
                                                                                item?.bib_is_exist
                                                                                    ? { ...item, duplicate_mode: opt.id }
                                                                                    : item
                                                                            )
                                                                        )
                                                                    }}>
                                                                    全部套用：{opt?.name}
                                                                </Button>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={24}>
                                                    <Tabs
                                                        activeKey={selectedTab}
                                                        onChange={(value) => setSelectedTab(value)}
                                                        items={[
                                                            { key: "全部", tab: "全部" },
                                                            { key: "重複書目", tab: "重複書目" },
                                                            { key: "無重複書目", tab: "無重複書目" },
                                                        ]}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableHead className="w-[20px]" >#  </TableHead>
                                                <TableHead className="w-[100px]">圖片</TableHead>
                                                <TableHead className="w-[180px]">書目名稱</TableHead>
                                                <TableHead>作者</TableHead>
                                                <TableHead>ISBN</TableHead>
                                                <TableHead className="w-[130px]">是否重複</TableHead>
                                                <TableHead className="w-[100px]">操作</TableHead>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody style={{}}>
                                            {filteredData?.map((value, index) => (
                                                <TableRow key={value?.key}>
                                                    <TableCell  >
                                                        <Button type="link" onClick={() => {
                                                            Modal.info({
                                                                width: '1000px',
                                                                title: value?.bib_title,
                                                                okText: "關閉",
                                                                content: <Row>
                                                                    <Col span={24}>
                                                                        <Row>
                                                                            <Col span={24}>
                                                                                <Row>
                                                                                    <Col span={3}>
                                                                                        leader
                                                                                    </Col>
                                                                                    <Col span={21}>
                                                                                        {value?.metadata?.leader}
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col span={24}>
                                                                        <Row>
                                                                            {value?.metadata?.controlfield.map((field) => {
                                                                                return (
                                                                                    <Col span={24}>
                                                                                        <Row>
                                                                                            <Col span={3}>
                                                                                                {field?.tag}
                                                                                            </Col>
                                                                                            <Col span={21}>
                                                                                                {field?.text}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )
                                                                            })}
                                                                        </Row>
                                                                    </Col>
                                                                    <Col span={24}>
                                                                        <Row gutter={[8, 8]}>
                                                                            {value?.metadata?.datafield.map((field) => {
                                                                                return (
                                                                                    <Col span={24}>
                                                                                        <Row>
                                                                                            <Col span={3}>
                                                                                                <Row gutter={[4, 4]}>
                                                                                                    <Col>
                                                                                                        {field?.tag}
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        {field?.ind1}
                                                                                                    </Col>
                                                                                                    <Col>
                                                                                                        {field?.ind2}
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                            <Col span={21}>
                                                                                                <Row>
                                                                                                    {
                                                                                                        field?.subfield?.map((sub) => {
                                                                                                            return (
                                                                                                                <Col span={24}>
                                                                                                                    <Row gutter={[4, 4]} >
                                                                                                                        <Col>
                                                                                                                            {sub?.code}
                                                                                                                        </Col>
                                                                                                                        <Col>
                                                                                                                            {sub?.text}
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                </Col>
                                                                                                            )
                                                                                                        })
                                                                                                    }
                                                                                                </Row>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                )
                                                                            })}
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            })
                                                        }}>{value?.key}</Button>
                                                    </TableCell>
                                                    <TableCell className="font-medium">
                                                        {value?.file_id ? <ImageFileId
                                                            file_id={value?.file_id}
                                                        /> : <>無綁定圖片</>}
                                                    </TableCell>
                                                    <TableCell className="font-medium">{value?.bib_title}</TableCell>
                                                    <TableCell>{value?.bib_author}</TableCell>
                                                    <TableCell>{(value?.bib_isbn || [])?.find(_ => true)}</TableCell>
                                                    <TableCell style={{
                                                        color: value?.bib_is_exist
                                                            ? "#721C24"
                                                            : "#155724"
                                                    }}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            {value?.bib_is_exist ?
                                                                <>
                                                                    <FaCopy />
                                                                    <span>重複書目</span>
                                                                </>
                                                                :
                                                                <>
                                                                    <FaPlus />
                                                                    <span>可新增書目</span>
                                                                </>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell>
                                                        {showImportStatus({ status_name: value?.import_status, message: value?.import_message })}

                                                        {value?.bib_is_exist ?
                                                            <Radio.Group
                                                                key={index}
                                                                value={value?.duplicate_mode}
                                                                className="flex flex-col gap-2"
                                                                onChange={(e) => {
                                                                    setTempBibData((pre) =>
                                                                        pre.map((item) =>
                                                                            item.key === value.key
                                                                                ? { ...item, duplicate_mode: e }
                                                                                : item
                                                                        )
                                                                    )
                                                                }}
                                                            >
                                                                {duplicateOptions.map((opt) => (
                                                                    <Radio key={opt?.id} value={opt?.id}>
                                                                        {opt?.name}
                                                                    </Radio>
                                                                ))}
                                                            </Radio.Group>
                                                            : <></>}
                                                        <div style={{ display: "flex", alignItems: "center", color: value?.bib_is_exist ? "#721C24" : "#155724" }}>
                                                            <Button type="link"
                                                                onClick={() => {
                                                                    setTempBibData(prev => prev.filter(item => item?.key !== value?.key))
                                                                }}>
                                                                刪除
                                                            </Button>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>

                                        </TableFooter>
                                    </Table>
                                </Col>
                            </Row>
                        </Col>
                    )}
                </Row>
            </Col>
        </Row>
    </>
    )
}


const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
-ms-flex-direction: column;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
flex-wrap: wrap;
`

const ContainerForm = styled.div`
display: flex;
flex-direction: column;
gap: inherit;
}
`

const Title = styled.div`
text-align: left;
width: 90%;
font-size: 1.6em;
font-weight: 600;
}
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
`

const Em20 = styled.div`
width: 20em;
`

export default StageMARCRecord
